import { render, staticRenderFns } from "./DataLinked.vue?vue&type=template&id=8b650448&scoped=true&"
import script from "./DataLinked.vue?vue&type=script&lang=js&"
export * from "./DataLinked.vue?vue&type=script&lang=js&"
import style0 from "./DataLinked.vue?vue&type=style&index=0&id=8b650448&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b650448",
  null
  
)

export default component.exports